/**
 * 搜索页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const searchCommonConfig = {
  texts: {
    placeholder: 'Search for fiction',
    cancel: 'Cancel',
    loading: 'Loading...',
    noResults: 'No search results',
    startReading: 'Start Reading',
    completed: 'Completed',
    ongoing: 'Ongoing',
    noMore: 'No more ~',
  },
  colors: {
    inputBg: '#0000000A', // bg-b-light
  },
}
